"use strict";
/**
 * @name SummaryList
 *
 * @description
 *  A component to render a 'dot' separated list of items.  See the Teamsnap patterns library for more information.
 *    https://teamsnap-ui-patterns.netlify.com/patterns/components/summary-list.html
 *
 * @example
 *  <SummaryList
 *    heading='Example Header'
 *    items={[
 *      { description: 'Item One', value: '$75.00' },
 *      { description: 'Item Two', value: '$100.00', isFooterRow: true },
 *    ]}
 *    footer={ {description: 'Balance', '$175.00'} }/>
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        description: PropTypes.node.isRequired,
        value: PropTypes.node.isRequired,
        key: PropTypes.string,
        mods: PropTypes.string,
        style: PropTypes.object,
    })).isRequired,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    footer: PropTypes.shape({
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    hasBorder: PropTypes.bool,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
};
var SummaryList = function (_a) {
    var items = _a.items, heading = _a.heading, subHeading = _a.subHeading, footer = _a.footer, className = _a.className, mods = _a.mods, style = _a.style, hasBorder = _a.hasBorder, testId = _a.testId, otherProps = _a.otherProps;
    var renderColumn = function (value) { return React.createElement("span", null, value); };
    var renderHeading = function () {
        return (React.createElement("h3", { className: "SummaryList-heading" },
            renderColumn(heading),
            subHeading && renderColumn(subHeading)));
    };
    var renderItem = function (item) {
        var listClasses = (0, helpers_1.getClassName)('SummaryList-item', item.isFooterRow && 'SummaryList-item--footer', item.mods);
        return (React.createElement("li", { key: item.key || item.description, className: listClasses, style: item.style },
            renderColumn(item.description),
            renderColumn(item.value)));
    };
    var hasHeading = heading || subHeading;
    var summaryClasses = (0, helpers_1.getClassName)(className, !hasHeading && 'SummaryList--no-heading', mods);
    var sectionStyle = hasBorder ? {} : { border: 0 };
    return (React.createElement("div", __assign({ className: summaryClasses, style: style, "data-testid": testId }, otherProps),
        hasHeading && renderHeading(),
        React.createElement("ul", { className: "SummaryList-section", style: sectionStyle }, items.map(renderItem)),
        footer && (React.createElement("div", { className: "SummaryList-footer" },
            React.createElement("h3", null,
                footer.description,
                React.createElement("span", null, footer.value))))));
};
SummaryList.defaultProps = {
    heading: null,
    subHeading: null,
    footer: null,
    className: 'SummaryList',
    mods: null,
    style: {},
    hasBorder: true,
    testId: null,
    otherProps: {},
};
exports.default = SummaryList;
